import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DOCUMENT_DETAILS_META_FEATURE_KEY, DocumentDetailsMetaState } from './document-details-meta.reducer';

export const selectDocumentDetailsMetaState = createFeatureSelector<DocumentDetailsMetaState>(
  DOCUMENT_DETAILS_META_FEATURE_KEY
);

export const selectDocumentDetailsMeta = createSelector(
  selectDocumentDetailsMetaState,
  (state) => state.documentDetailsMeta
);

export const selectDocumentDetailsMetaLoaded = createSelector(selectDocumentDetailsMetaState, (state) => state.loaded);

export const selectDocumentDetailsMetaError = createSelector(selectDocumentDetailsMetaState, (state) => state.error);
